<p-dialog *ngIf="dialogConfirmed" [header]="dialogData.user.name" [modal]="true" [draggable]="true"
  [(visible)]="dialogConfirmedShow" width="400" [closable]="false">
  <ng-container *ngFor="let doc of dialogData.documents">
    <app-partipian-document [doc]="doc"></app-partipian-document>
  </ng-container>
  <div class="allDocumentsValid">
    {{ appSettings.translate[appSettings.selectedLang]['allDocumentsValid'] }}
    <p-inputSwitch [(ngModel)]="dialogData.allDocumentsValid"></p-inputSwitch>
  </div>
  <div>
    {{ appSettings.translate[appSettings.selectedLang]['change_start_fee'] }}
    <input type="number" min="0" step="1" pInputText [(ngModel)]="dialogData.startFee"
      (ngModelChange)="dialogData.startFee = sanitizePositiveInt($event)" />
  </div>
  <p-footer>
    <div class="ui-inputgroup document-buttons">
      <p-button [label]="appSettings.translate[appSettings.selectedLang]['cancel']" (click)="saveDocuments()"
        styleClass="ui-button-danger"></p-button>
      <p-button [label]="appSettings.translate[appSettings.selectedLang]['ok']"
        (click)="saveDocuments(dialogData)"></p-button>
    </div>
  </p-footer>
</p-dialog>